module.exports = __webpack_public_path__ + "static/media/circle-yellow.41542930.svg";